import { Component } from '@angular/core';
import { GroupIStateService } from './service/groupi-state.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
	title = 'lios-groupI-mfe';
	isAuthorized: boolean = false;
	AUthToken: boolean = false;
	clientHeight: number;
	constructor(private readonly state: GroupIStateService) {
		this.clientHeight = window.innerHeight;
	}

	ngOnInit() {
		if (localStorage.getItem('toyotaGUID')) {
			this.AUthToken = true;
		}


		// debugger
		this.state.roleState.subscribe((value) => {
			if (value) {
				this.isAuthorized = true;
			}
		});
	}

}
